/**
 * Formats carat weight for PDP display.
 * Customization API can return high-precision floats; legacy PDP showed clean 2-decimal values.
 */
export function formatPdpCarat(carat: number): string {
  return Number(carat.toFixed(3)).toString();
}
